/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum HMResult {
    SUCCESSFUL = 'SUCCESSFUL',
    FAILED = 'FAILED'
}


export function HMResultFromJSON(json: any): HMResult {
    return HMResultFromJSONTyped(json, false);
}

export function HMResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): HMResult {
    return json as HMResult;
}

export function HMResultToJSON(value?: HMResult | null): any {
    return value as any;
}

